
import { logIn } from '@/api';
import { AppErrors } from '@/models/main';
import { LoginForm } from '@/models/auth';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  computed: {
    ...mapState(['alertTimeout', 'errors']),
  },
})
export default class Login extends Vue {
  public $refs!: {
    form: HTMLElement;
  };
  private alertTimeout!: number;
  public formValid = false;
  public isLoading = false;

  public form: LoginForm = {
    username: '',
    password: '',
  };
  private errors: AppErrors;

  public async onSubmit(): Promise<void> {
    if ((this.$refs.form as HTMLFormElement).validate()) {
      try {
        this.isLoading = true;
        const result = await logIn(this.form);
        if (result) {
          await this.$router.push('/');
        } else {
          notifyNetworkError({ text: 'Username or password invalid', group: 'login' });
        }
      } catch (e) {
        notifyNetworkError({ text: 'Username or password invalid', group: 'login' });
      } finally {
        this.isLoading = false;
      }
    }
  }

  private mounted() {
    if (this.errors.loginError) {
      notifyNetworkError({ text: this.errors.loginError, group: 'login' });
    }
  }
}
